var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E6F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    d: "M22.001 12C23.6576 12.0002 25.0008 13.3434 25.001 15C25.001 16.6567 23.6577 17.9998 22.001 18C20.3441 18 19 16.6569 19 15C19.0002 13.3433 20.3442 12 22.001 12ZM13 7C15.2091 7.00011 17 8.79092 17 11C17 13.2091 15.2091 14.9999 13 15C10.7908 15 9 13.2092 9 11C9.00003 8.79086 10.7908 7 13 7Z",
    fill: "#3B58FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9831 17C17.7711 17 21.7047 19.2933 21.9977 24.2002C22.0094 24.3957 21.9979 25 21.2467 25H4.72721C4.47642 25 3.97954 24.4592 4.00065 24.1992C4.38832 19.4266 8.26164 17.0001 12.9831 17ZM21.6022 19.002C25.0085 19.0394 27.7904 20.7607 27.9997 24.4004C28.0081 24.5474 27.9983 24.9998 27.4567 25H23.6012C23.6011 22.7496 22.8569 20.6729 21.6022 19.002Z",
    fill: "#3B58FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickUserIcon);
export default __webpack_public_path__ + "static/media/quick-user-icon.6523e05394b11d58811995046ef898ce.svg";
export { ForwardRef as ReactComponent };